import { Component } from "@/types"
import { cx } from "@/utils/cx"
import { ButtonLink } from "@/ui/atoms/controls/ButtonLink"
import { SansMark } from "@/ui/atoms/branding/SansMark"

export const COMPONENT_NAME = "SANSSignInButton"

export const presets = {}

export interface Props extends Component {}

export function SANSSignInButton({ className, testId = COMPONENT_NAME }: Props) {
  return (
    <ButtonLink
      variant="sans"
      label="Sign in with SANS"
      href="/sso/auth"
      width="full"
      labelPrefix={<SansMark />}
      prefetch={false}
      className={cx(``, className)}
      testId={testId}
    />
  )
}
